/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationPricingsIndividualHealthGranteesMutation from '../graphql/mutations/SaveSimulationPricingsIndividualHealthGranteesMutation.js';

export const useSaveSimulationPricingsIndividualHealthGranteesMutation = () => {
  return useCommitMutation(SaveSimulationPricingsIndividualHealthGranteesMutation, {
    dataProp:
      'saveSimulationPricingsIndividualHealthGrantees_M_simulation_pricings_individual_health'
  });
};

export default useSaveSimulationPricingsIndividualHealthGranteesMutation;
